/* Scrollbar hidden via the shared `.scrollbar-hide` utility. */
.switcher {
	display: flex;
	gap: var(--spacing-2);
	padding-block-end: var(--spacing-2);
	overflow-x: auto;

	/* Fade the trailing edge so the five status tabs hint "scroll for more" when
	   they overflow the phone width. Transparency-only, so both themes get it free
	   (mirrors the board's own overflow fade). */
	mask-image: linear-gradient(to right, black calc(100% - 1.5rem), transparent);

	& .tab {
		display: inline-flex;
		flex: 0 0 auto;
		gap: var(--spacing-1-5);
		align-items: center;

		/* Slightly below the toolbar buttons — a secondary, quieter control row. */
		min-block-size: 1.75rem;
		padding: 0 var(--spacing-2);
		font-size: var(--font-size-sm);
		font-weight: var(--font-weight-medium);
		color: var(--colour-text-secondary);
		white-space: nowrap;
		cursor: pointer;
		background: var(--colour-background-surface);
		border: 1px solid var(--colour-border-subtle);
		border-radius: var(--radius-full);

		&[data-active='true'] {
			color: var(--colour-text-on-brand);
			background: var(--colour-brand-primary);
			border-color: var(--colour-brand-primary);
		}

		/* The count sits in a tinted chip — a translucent take on the current text
		   colour, so it reads on both the surface and the active brand pill. */
		& .count {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			min-inline-size: 1.125rem;
			padding: 0 var(--spacing-1);
			font-size: var(--font-size-xs);
			font-variant-numeric: tabular-nums;
			background: color-mix(in srgb, currentcolor 16%, transparent);
			border-radius: var(--radius-full);
		}
	}
}
